export function checkLocaleData(locale: string): string | null {
  if (/^[a-z]{2}-[a-z]{2}$/i.test(locale)) {
    const [language, region] = locale.split('-');
    return [language?.toLowerCase(), region?.toUpperCase()].join('-');
  }

  return null;
}
